module.exports = __webpack_public_path__ + "static/img/icon3.d3f79880.png";